/**
 * Page Tracking Hook for SPA Navigation
 * Automatically tracks page views when route changes
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/gtm';
import { extractSeoRoutePath, isPrivateSeoRoute } from '@/lib/seo-indexability';

export function usePageTracking() {
  const location = useLocation();
  const lastTrackedPath = useRef<string | null>(null);
  
  useEffect(() => {
    const currentPath = location.pathname + location.search;
    const routePath = extractSeoRoutePath(location.pathname);

    if (isPrivateSeoRoute(routePath)) {
      return;
    }

    // Prevent duplicate tracking for the exact same route state
    if (lastTrackedPath.current === currentPath) {
      return;
    }

    lastTrackedPath.current = currentPath;
    
    // Get page title from document or meta
    const pageTitle = document.title;
    
    // Track initial page load and subsequent SPA navigations.
    // GTM is injected dynamically, so relying on GTM's default first page_view
    // can miss organic entrances entirely.
    trackPageView(currentPath, pageTitle);
    
  }, [location.pathname, location.search]);
}

export default usePageTracking;
